"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var common_1 = require("@angular/common");
var keywordsearch_service_1 = require("./services/keywordsearch.service");
var environment_1 = require("@covestro/config-environments/environment");
var terrific_on_init_1 = require("@covestro/pattern-library/dist/ng/aot/src/lib/helpers/angular-terrific-on-init/terrific-on-init");
var technical_property_popup_component_1 = require("@covestro/pattern-library/dist/ng/aot/src/lib/molecules/technical-property-popup/ng/technical-property-popup.component");
var KeywordSearchComponent = /** @class */ (function (_super) {
    __extends(KeywordSearchComponent, _super);
    function KeywordSearchComponent(keywordSearchService, route, router, location, renderer) {
        var _this = _super.call(this, renderer) || this;
        _this.keywordSearchService = keywordSearchService;
        _this.route = route;
        _this.router = router;
        _this.location = location;
        _this.renderer = renderer;
        _this.environment = environment_1.environment;
        /**
         * Contains all already loaded brands
         */
        _this._showSpinner = true;
        _this._totalCount = 0;
        _this._currentCount = 0;
        _this._searchLoading = true;
        _this._appInitialized = false;
        _this._errorHasOccured = false;
        _this._terrificHasBootstrapped = false;
        return _this;
    }
    KeywordSearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.validateAndSetConfigurationItems();
        this.location.onPopState(function () {
            _this._showSpinner = true;
            _this._searchLoading = true;
        });
        _super.prototype.ngOnInit.call(this);
    };
    KeywordSearchComponent.prototype.onTerrificBootstrap = function () {
        this._terrificHasBootstrapped = true;
    };
    Object.defineProperty(KeywordSearchComponent.prototype, "appInitialized", {
        get: function () {
            return this._appInitialized;
        },
        enumerable: true,
        configurable: true
    });
    KeywordSearchComponent.prototype.showLoadMoreButton = function () {
        return this._currentCount < this._totalCount;
    };
    KeywordSearchComponent.prototype.showResults = function () {
        return this._totalCount > 0;
    };
    KeywordSearchComponent.prototype.isAnyFilterOpen = function () {
        return (this._regionFilter.isOpen ||
            this._industryApplicationFilter.isOpen ||
            this._keywordTypeFilter.isOpen ||
            this._technologiesFilter.isOpen ||
            this._materialAttributeFilter.isOpen);
    };
    KeywordSearchComponent.prototype.onSearchChanges = function (val) {
        this._searchText = val;
    };
    KeywordSearchComponent.prototype.validateAndSetConfigurationItems = function () {
        var _this = this;
        this.keywordSearchService.getConfig().subscribe(function (config) {
            if (!config) {
                return;
            }
            _this._config = config;
        });
        this._appInitialized = true;
    };
    Object.defineProperty(KeywordSearchComponent.prototype, "terrificHasBootstrapped", {
        get: function () {
            return this._terrificHasBootstrapped;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeywordSearchComponent.prototype, "autosuggestSearchConfig", {
        get: function () {
            return this._config.downloadTableFilterKeywordsData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeywordSearchComponent.prototype, "keySearchConfig", {
        get: function () {
            return this._config.downloadTableFilterKeywordsData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeywordSearchComponent.prototype, "searchText", {
        get: function () {
            return this._searchText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeywordSearchComponent.prototype, "searchButtonText", {
        get: function () {
            return this._config.downloadTableFilterKeywordsData.searchButtonText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeywordSearchComponent.prototype, "errorHasOccured", {
        get: function () {
            return this._errorHasOccured;
        },
        enumerable: true,
        configurable: true
    });
    KeywordSearchComponent.MARKET_SWITCH_COOKIE = 'cov_market';
    KeywordSearchComponent.MARKET_SWITCH_TOOLTIP_COOKIE = 'cov_market_tooltip';
    return KeywordSearchComponent;
}(terrific_on_init_1.TerrificOnInit));
exports.KeywordSearchComponent = KeywordSearchComponent;
